<template>
  <PageContact
    :branch-primary="branchPrimary"
    :branches="typeof branches !== 'undefined' && branches && branches.entities ? branches.entities : []"
    :contact="this.$store.state.globals.contact"/>
</template>

<script>
import AppRouteMixin from '~/mixins/AppRouteMixin'
import PageContact from '@theme/components/content/PageContact'

const PAGE = {
  name: 'RouteContact',
  nuxtI18n: {
    paths: {
      cs: '/kontakt',
      de: '/impressum',
      en: '/contact',
      sk: '/kontakt',
    },
  },
  middleware({ store }) {
    store.commit('locale/SET_ALTERNATIVE_PATHS', PAGE.nuxtI18n.paths)
  },
  components: {
    PageContact,
  },
  mixins: [AppRouteMixin],
  async asyncData({ app, store }) {
    store.commit('locale/SET_CANONICALS')
    const data = {
      branches: store.dispatch('branch/LOAD_BRANCHES', { page: 0, perPage: 3 }),
      branchPrimary:
        app.$themeSettings.components.PageContact.showEmployees ||
        app.$themeSettings.components.PageContact.showPrimaryBranchMap
          ? store.dispatch('branch/LOAD_BRANCH_PRIMARY')
          : null,
    }
    return await Promise.allValues(data)
  },
}
export default PAGE
</script>
